module.exports = __webpack_public_path__ + "static/media/Gotham-Book.1fb4e921.woff";